import { withStyles } from '@material-ui/core/styles';
import { Accordion, AccordionSummary } from '@material-ui/core';

export const StyledAccordionSummary = withStyles((theme) => ({
  root: {
    minHeight: 20,
    maxHeight: 20,
    backgroundColor: '#f0f0f0',
    '&.Mui-expanded': {
      minHeight: 20,
      maxHeight: 20,
      backgroundColor: '#f0f0f0',
    },
  },
  expandIcon: {
    order: -1
  }
  }))(AccordionSummary);

export const StyledAccordion = withStyles((theme) => ({
    root: {
      borderBottom: '1px solid grey',
      boxShadow: 'none',
    },
  }))(Accordion);
